import { Icon } from "@chakra-ui/react";
import React from "react";

export const OnlineIcon = () => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
    >
      <title>wifi [#1021]</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-343.000000, -3642.000000)"
          fill="cyan"
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M287,3494.02134 L287,3496 L288.992883,3496 C288.992883,3494.90679 288.101068,3494.02134 287,3494.02134 M287,3489.91464 L287,3491.89329 C288.992883,3491.89329 291.035587,3493.87195 291.035587,3495.85061 L293.02847,3495.85061 C293.02847,3492.88262 289.989324,3489.91464 287,3489.91464 M287,3482 L287,3483.97866 C293.975089,3483.97866 299.007117,3488.92531 299.007117,3495.85061 L301,3495.85061 C301,3487.93598 294.97153,3482 287,3482 M297.014235,3495.85061 L295.021352,3495.85061 C295.021352,3490.90396 290.985765,3487.93598 287,3487.93598 L287,3485.95732 C292.978648,3485.95732 297.014235,3489.91464 297.014235,3495.85061"
              id="wifi-[#1021]"
            ></path>
          </g>
        </g>
      </g>
    </Icon>
  );
};
